import Logo from "../../../../../images/logo.svg";
import classNames from "classnames";
var classes = {
    base: "step-header flex items-center flex-none h-24 bg-white shadow-spread max-lg:hidden z-40",
};
var StepHeader = function (_a) {
    var className = _a.className;
    return (<div className={classNames(classes.base, className)}>
      <div className="container">
        <a href="/" aria-label="Navigation vers la page d'accueil">
          <img src={Logo} alt="Logo de Majeures" width={196} height={38}/>
        </a>
      </div>
    </div>);
};
export default StepHeader;
